import PlusIcon from "../../../../assets/icons/PlusIcon";
import MinusIcon from "../../../../assets/icons/Minus";
import {
  CounterContainer,
  Label,
  ButtonRow,
  IconButton,
  ValueBox,
} from "./styles";

/**
 * @param {{
 *   label: string,
 *   value: number,
 *   onChange: (value: number) => void,
 *   min?: number,
 *   color?: string
 * }} props
 */
export default function CounterButton({
  label,
  value,
  onChange,
  min = 0,
  color = "#1976d2",
}) {
  return (
    <CounterContainer>
      <Label color={color}>{label}</Label>
      <ButtonRow>
        <IconButton
          type="button"
          onClick={() => onChange(value - 1)}
          disabled={value <= min}
          color={color}
          aria-label={`Diminuir ${label}`}
        >
          <MinusIcon width={22} height={22} color={color} />
        </IconButton>
        <ValueBox color={color}>{value}</ValueBox>
        <IconButton
          type="button"
          onClick={() => onChange(value + 1)}
          color={color}
          aria-label={`Aumentar ${label}`}
        >
          <PlusIcon width={22} height={22} color={color} />
        </IconButton>
      </ButtonRow>
    </CounterContainer>
  );
}
